import request from './request';

function query() {
  return request({
    url: `/eventsLog/findAll`,
    method: 'get'
  });
}

export default {
  query,
};